import React, { useContext } from "react";
import { ThemeContext } from "../../contexts/ThemeContext";
import { LanguageContext } from "../../contexts/LanguageContext";
import { StyledAbout, AboutContent, AboutText, AboutMVV } from "./styles";

const About = () => {
  const { theme } = useContext(ThemeContext);
  const { language, translations } = useContext(LanguageContext);

  const values = translations[language].valuesList;

  return (
    <StyledAbout id="sobre">
      <div className="container">
        <h2
          dangerouslySetInnerHTML={{
            __html: translations[language].aboutTitle,
          }}
        />
        <AboutContent>
          <AboutText data-aos="fade-right">
            <p>{translations[language].aboutP1}</p>
            <p>{translations[language].aboutP2}</p>
            <p>{translations[language].aboutP3}</p>
          </AboutText>
          <AboutMVV data-aos="fade-left">
            <div className="mvv-cards">
              <div className="card mission" data-aos="zoom-in">
                <h3>{translations[language].missionTitle}</h3>
                <p>{translations[language].missionText}</p>
              </div>
              <div className="card vision" data-aos="zoom-in">
                <h3>{translations[language].visionTitle}</h3>
                <p>{translations[language].visionText}</p>
              </div>
              <div className="card values" data-aos="zoom-in">
                <h3>{translations[language].valuesTitle}</h3>
                <ul className="valores-list">
                  {values.map((item, index) => (
                    <li key={index}>
                      <svg
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M17.091 8.18182L10.091 15.1818L6.90918 12"
                          stroke="#ff6b00"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </AboutMVV>
        </AboutContent>
      </div>
    </StyledAbout>
  );
};

export default About;
